export const elementSize = {
  header: '51px',
  content: '100%',
  sidebar: '440px',
  toolbar: '60px',
};
